import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'components.Result.title',
    defaultMessage: 'Result',
    description: '请修改',
  },
  Finish: {
    id: 'components.Result.Finish',
    defaultMessage: 'Done',
    description: '请修改',
  },
  Refresh: {
    id: 'components.Result.Refresh',
    defaultMessage: 'Refresh',
    description: '请修改',
  },
  TryAgain: {
    id: 'components.Result.TryAgain',
    defaultMessage: 'Try Again',
    description: '请修改',
  },
  Processing: {
    id: 'components.Result.Processing',
    defaultMessage: 'Processing...',
    description: '请修改',
  },
  PaidSuccessfully: {
    id: 'components.Result.PaidSuccessfully',
    defaultMessage: 'Paid Successfully',
    description: '请修改',
  },
  Failed: {
    id: 'components.Result.Failed',
    defaultMessage: 'Failed',
    description: '请修改',
  },
  Nopaymentfoundredirecting: {
    id: 'components.Result.Nopaymentfoundredirecting',
    defaultMessage: 'No payment found, redirecting...',
    description: '请修改',
  },
  Tryanotherpaymentmethodtocontinue: {
    id: 'components.Result.Tryanotherpaymentmethodtocontinue',
    defaultMessage: 'Try another payment method to continue.',
    description: '请修改',
  },
  Afewsecondstowaitforyourpaymentresult: {
    id: 'components.Result.Afewsecondstowaitforyourpaymentresult',
    defaultMessage: 'A few seconds to wait for your payment result.',
    description: '请修改',
  },
  YouCanClosePage: {
    id: 'components.Result.YouCanClosePage',
    defaultMessage: 'You can close this page now.',
    description: 'Shown when the browser refuses to close the page on Done',
  },
  RedirectingInSeconds: {
    id: 'components.Result.RedirectingInSeconds',
    // 不用 ICU plural：react-intl v3 的 plural 依赖原生 Intl.PluralRules，
    // 老 webview（iOS≤12 / 旧 Android WebView）没有它会把原始 ICU 串渲染到支付页
    defaultMessage: 'Redirecting in {seconds}s...',
    description: 'Countdown before redirect to merchant',
  },
  OrderAmount: {
    id: 'components.Result.OrderAmount',
    defaultMessage: 'Order Amount',
    description: '请修改',
  },
  Discount: {
    id: 'components.Result.Discount',
    defaultMessage: 'Discount',
    description: '请修改',
  },
  PaymentMethod: {
    id: 'components.Result.PaymentMethod',
    defaultMessage: 'Payment Method',
    description: '请修改',
  },
  TransactionDetails: {
    id: 'components.Result.TransactionDetails',
    defaultMessage: 'Transaction Details',
    description: '请修改',
  },
  MerchantOrderNo: {
    id: 'components.Result.MerchantOrderNo',
    defaultMessage: 'Merchant Order No.',
    description: '请修改',
  },
  OrderNo: {
    id: 'components.Result.OrderNo',
    defaultMessage: 'Order No.',
    description: '请修改',
  },
  SavedCardfornexttime: {
    id: 'components.Result.SavedCardfornexttime',
    defaultMessage: 'Save card details with your mobile',
    description: '请修改',
  },
  Onlyoneclick: {
    id: 'components.Result.Onlyoneclick',
    defaultMessage: 'Make payment using your mobile number',
    description: '请修改',
  },
  ToSave: {
    id: 'components.Result.ToSave',
    defaultMessage: 'Save Card',
    description: '请修改',
  },
  InstallmentInfo: {
    id: 'components.Result.InstallmentInfo',
    defaultMessage: 'Installment Information',
    description: '请修改',
  },
  InstallmentPlan: {
    id: 'components.Result.InstallmentPlan',
    defaultMessage: 'Installment Plan',
    description: '请修改',
  },
  InstallmentNumber: {
    id: 'components.Result.InstallmentNumber',
    defaultMessage: 'Number of Installments',
    description: '请修改',
  },
  FirstInstallmentAmount: {
    id: 'components.Result.FirstInstallmentAmount',
    defaultMessage: 'First Installment',
    description: '请修改',
  },
  UpfrontFee: {
    id: 'components.Result.UpfrontFee',
    defaultMessage: 'Upfront Fee',
    description: '请修改',
  },
  TotalInstallmentAmount: {
    id: 'components.Result.TotalInstallmentAmount',
    defaultMessage: 'Total Installment Amount',
    description: '请修改',
  },
  ExternalReferenceNo: {
    id: 'components.Result.ExternalReferenceNo',
    defaultMessage: 'Reference No.',
    description: '请修改',
  },
  TermsAndConditions: {
    id: 'components.Result.TermsAndConditions',
    defaultMessage: 'Terms and Conditions',
    description: '请修改',
  },
  InstallmentsEnabledByVisa: {
    id: 'components.Result.InstallmentsEnabledByVisa',
    defaultMessage: 'Installments enabled by VISA',
    description: '请修改',
  },
  PlanAcceptanceId: {
    id: 'components.Result.PlanAcceptanceId',
    defaultMessage: 'Plan Acceptance ID',
    description: '请修改',
  },
  MonthlyPayment: {
    id: 'components.Result.MonthlyPayment',
    defaultMessage: 'Monthly Payment',
    description: '请修改',
  },
  MonthlyRate: {
    id: 'components.Result.MonthlyRate',
    defaultMessage: 'Monthly Rate',
    description: '请修改',
  },
  ProcessingFees: {
    id: 'components.Result.ProcessingFees',
    defaultMessage: 'Processing Fees',
    description: '请修改',
  },
  DccConversion: {
    id: 'components.Result.DccConversion',
    defaultMessage: 'Currency conversion',
    description: 'DCC section title on pay result',
  },
  DccChargedAmount: {
    id: 'components.Result.DccChargedAmount',
    defaultMessage: 'Amount in card currency',
    description: 'DCC total on result',
  },
  DccExchangeRate: {
    id: 'components.Result.DccExchangeRate',
    defaultMessage: 'Exchange rate',
    description: 'DCC rate on result',
  },
  DccMarkup: {
    id: 'components.Result.DccMarkup',
    defaultMessage: 'Markup Over Exchange Rate',
    description: 'DCC markup on result',
  },
  DccQuoteId: {
    id: 'components.Result.DccQuoteId',
    defaultMessage: 'DCC quote reference',
    description: 'DCC quote id on result',
  },
})
